import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Webplayer } from 'components';
import { getSingleBySlug } from 'redux/actions';
import { getSingle, getPlayerStatus } from 'redux/reducers';
import { getToken, isGuest } from 'redux/query';
import { useParams } from 'react-router-dom';
import { useWithSingle } from 'hookApi';
import { Spinner } from 'Common';

const SinglePlayerPage = () => {
  const dispatch = useDispatch();
  const { slug } = useParams();
  const { isFetching } = useWithSingle();

  const content = useSelector(getSingle);
  const playerStatus = useSelector(getPlayerStatus);
  const token = useSelector(getToken);
  const guest = useSelector(isGuest);

  useEffect(() => {
    dispatch(getSingleBySlug(slug));
    window.scrollTo(0, 0);
  }, [slug]);

  useEffect(() => {
    if (playerStatus === 'end') {
      dispatch(getSingleBySlug(slug));
    }
  }, [playerStatus]);

  useEffect(() => {
    dispatch(getSingleBySlug(slug));
  }, [token]);

  if (isFetching) {
    return <Spinner />;
  }

  return <Webplayer content={content} contentType="single" playerStatus={playerStatus} token={token} isGuest={guest} />;
};

export default SinglePlayerPage;
